const useStyles = () => {
    return {
          containerFooter:
              ' text-white flex justify-center my-6 mx-0 items-center',
          pFooter: 'flex text-sm items-center ring-2 ring-white px-2 py-1 rounded-full  hover:bg-rose-500 mb-2',
          spanFooter: 'px-1',
    };
  }
  
  export default useStyles;